import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'mathRound',
    standalone: false
})
export class MathRoundPipe implements PipeTransform {
    transform(value: number|null): number|null {
      return typeof value == 'number' ? Math.round(value) : value;
    }
}
